import { render, staticRenderFns } from "./plusLeveLUpRule.vue?vue&type=template&id=22add9e0&scoped=true&"
import script from "./plusLeveLUpRule.vue?vue&type=script&lang=js&"
export * from "./plusLeveLUpRule.vue?vue&type=script&lang=js&"
import style0 from "./plusLeveLUpRule.vue?vue&type=style&index=0&id=22add9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22add9e0",
  null
  
)

component.options.__file = "plusLeveLUpRule.vue"
export default component.exports